import { Controller } from '@hotwired/stimulus';
import { Dropdown } from 'bootstrap';

// #1964 ヘッダーのポップオーバーは同時に1つだけ開く。
// 配下のいずれかが開くタイミングで、他の開いているドロップダウンを閉じる。
export default class extends Controller {
  connect() {
    this.onShow = (event) => {
      // 開いているトグルは .show クラス (DOM 状態) で判定する。このページは
      // sprockets 側と webpack 側で bootstrap が二重ロードされており、開いた
      // インスタンスが自分の copy の instance map にいるとは限らないため、
      // getInstance ではなく getOrCreateInstance + hide() (DOM 状態を見て
      // 動作する) で閉じる。
      this.element.querySelectorAll('[data-bs-toggle="dropdown"].show').forEach((toggle) => {
        if (toggle === event.target) return;

        Dropdown.getOrCreateInstance(toggle).hide();
      });
    };
    this.element.addEventListener('show.bs.dropdown', this.onShow);
  }

  disconnect() {
    this.element.removeEventListener('show.bs.dropdown', this.onShow);
  }
}
